
import { generateNameSuggestionSuffix } from '@bingads-webui-campaign/audience-campaign-shared';
import { MAX_CONVERSIONS_VALUE } from '@bingads-webui-campaign-react/bid-strategy-component';
import { Scopes } from '@bingads-webui-campaign-react/goal-selector';
import { getBudgetRange } from '@bingads-webui-campaign-legacy/common-grid-config/budget/get-budget-range';
import timeZoneMapper from '@bingads-webui-component-legacy/timezonemapper/index';
import { URL_RULES_OPTIONS } from '@bingads-webui-campaign-react/url-rules';
import { getDefaultLocationTargetsViewModel, getDefaultLanguagesViewModel } from '@bingads-webui-campaign-react/wizard-shared-components';

export const getDefaultCampaignData = ({
  i18n,
  serverContext,
  providerId,
  salesCountry,
  localInventory,
  isFeedFiltered,
  feedLabel,
  cnMarketAccount,
}) => ({
  Name: `${generateNameSuggestionSuffix(i18n.getString(_TL_('PerformanceMax-Campaign')))}-${Math.floor(Math.random() * 100)}`,
  Status: 'Paused',
  TimeZone: timeZoneMapper.getAccountTimeZone(),
  Budget: {
    Amount: getBudgetRange(serverContext.CurrentAccount.CurrencyCode).Daily.Default,
    Type: 'DailyStandard',
  },
  Languages: getDefaultLanguagesViewModel(cnMarketAccount),
  BiddingScheme: {
    Type: MAX_CONVERSIONS_VALUE.type,
    TargetCpa: undefined,
    TargetRoas: undefined,
  },
  CampaignType: 'PerformanceMax',
  FinalUrlSuffix: '',
  TrackingUrlTemplate: '',
  UrlCustomParameters: [],
  locationTargets: getDefaultLocationTargetsViewModel(cnMarketAccount),
  adSchedules: {
    adScheduleUseSearcherTimeZone: undefined,
    dayTimeRanges: [],
    timeZone: undefined,
  },
  finalUrlExpansions: [],
  conversionGoals: {
    originalConversionGoals: [],
    goalSelection: [],
    goalScopeSelection: Scopes.ACCOUNT,
  },
  CampaignConversionGoal: {
    Goals: [],
  },
  ProviderId: providerId,
  IsFeedFiltered: isFeedFiltered,
  SalesCountry: salesCountry,
  FeedLabel: feedLabel,
  LocalInventoryAdsEnabled: localInventory,
  finalUrlExpansionOptOut: cnMarketAccount,
  autoGeneratedTextOptOut: cnMarketAccount,
  autoGeneratedImageOptOut: cnMarketAccount,
  costPerSaleOptOut: false,
});

export const getDefaultAssetGroup = ({ i18n, businessName, storeFinalUrl = null }) => ({
  Name: generateNameSuggestionSuffix(i18n.getString(_TL_('AssetGroup'))),
  Status: 'Paused',
  Images: {
    ImageList: [],
    IsOptional: true,
  },
  BusinessName: businessName,
  FinalUrls: [storeFinalUrl],
  FinalUrlForRecommendation: storeFinalUrl,
  UrlRulesOption: URL_RULES_OPTIONS.All,
});

